module.exports = __webpack_public_path__ + "static/media/Inter-SemiBold.ec60b23f.ttf";